/**
 * Read-only fetcher for the Person 360 API (B5, issue #453) — the universal
 * member drawer's (issue #458) ONE request per person.
 *
 * `GET /api/desk/person/<id>/full` — no trailing slash (matches the
 * `apps.desk.urls` convention). GET-only by construction: the endpoint is
 * read-only server-side (identity/standing/membership/payments/engagement/
 * lifecycle/AC-mirror/notes), so there is deliberately no write helper here.
 */
import { apiRequest } from "./client";
import type { PersonCase, PersonFull } from "./person360.types";

export function getPersonFull(personId: number): Promise<PersonFull> {
  return apiRequest<PersonFull>(`/desk/person/${personId}/full`);
}

/** `GET /api/desk/person/<id>/case` — their licence change and wave-2 hold, if any (#714). */
export function getPersonCase(personId: number): Promise<PersonCase> {
  return apiRequest<PersonCase>(`/desk/person/${personId}/case`);
}
